import { Injectable, inject } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthenticatedPreloadingStrategy implements PreloadingStrategy {
  private authService = inject(AuthService);

  preload(route: Route, load: () => Observable<any>): Observable<any> {
    if (!this.authService.isAuthenticated()) {
      // Not logged in — don't preload anything (e.g. on the login page)
      return of(null);
    }
    // Authenticated — wait 2s so the dashboard fully renders before background downloads start
    return timer(2000).pipe(mergeMap(() => load()));
  }
}
